export function archiveLabel(sheet) {
    const source = sheet.source_metadata || sheet.source_payload || {};
    const name = source.source_file_name || sheet.name || source.source_sheet_name || 'Архивный табель';
    const object = sheet.object_name || sheet.building_name;
    return [name, object && !name.includes(object) ? object : null, `№${sheet.id}`].filter(Boolean).join(' · ');
}
